export default "__VITE_ASSET__CucF8eE$__"